import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { cn } from '@/lib/utils';
import { MarkdownContent } from '@/components/ui/MarkdownContent';

interface RaceDescriptionProps {
    description: string;
}

export function RaceDescription({ description }: RaceDescriptionProps) {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className="bg-slate-50 rounded-3xl p-5 border border-slate-100/50">
            <div className={cn("overflow-hidden transition-all duration-300 relative", isExpanded ? "max-h-[500px]" : "max-h-16")}>
                <MarkdownContent content={description} />
                {!isExpanded && description.length > 100 && (
                    <div className="absolute bottom-0 left-0 w-full h-12 bg-gradient-to-t from-slate-50 to-transparent" />
                )}
            </div>
            {description.length > 100 && (
                <button onClick={() => setIsExpanded(!isExpanded)} className="mt-2 flex items-center gap-1 text-xs font-bold text-slate-400 hover:text-emerald-600 uppercase tracking-wide">
                    {isExpanded ? <>{t('btn.readLess')} <ChevronUp size={14} /></> : <>{t('btn.readMore')} <ChevronDown size={14} /></>}
                </button>
            )}
        </div>
    );
}
